/** Google Reviews module — isolated from consent flows. */

export const GOOGLE_REVIEWS_MODULE = {
  publicPathPrefix: '/review',
  clinicPath: '/clinic/reviews',
  sendPath: '/clinic/consents',
};

export const DEFAULT_REVIEW_CONFIG = {
  enabled: false,
  googleReviewUrl: '',
};

export const PUBLIC_CONFIG_COLLECTION = 'googleReviewConfig';
export const FEEDBACK_COLLECTION = 'practiceFeedback';
export const EVENTS_COLLECTION = 'reviewEvents';

export const REVIEW_EVENT_TYPES = {
  LINK_SENT: 'link_sent',
  EMAIL_OPENED: 'email_opened',
  LINK_OPENED: 'link_opened',
  GOOGLE_CLICKED: 'google_clicked',
  FEEDBACK_SUBMITTED: 'feedback_submitted',
};
